import React from 'react';
import Pill from '../interaction/Pill';
import { getFrequentRoles } from '../utils/roleFrequency';

/**
 * Reusable shortcut pills for frequently selected roles.
 *
 * Props:
 *   allRoles        — full list of role objects { id, name }
 *   selectedRoleIds — array of currently selected role IDs
 *   onToggle(roleId) — called when a pill is clicked (add or remove)
 */
export default function FrequentRolePills({ allRoles, selectedRoleIds, onToggle }) {
  // No memo — re-reads localStorage on every render so counts are always current.
  const frequent = getFrequentRoles(allRoles);

  if (!frequent.length) return null;

  return (
    <div style={{ marginTop: 4, marginBottom: 8 }}>
      <span style={{ fontSize: 11, color: 'var(--sp-text-muted)' }}>Quick add:</span>
      <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginTop: 4 }}>
        {frequent.map((role) => (
          <Pill
            key={role.id}
            label={role.id}
            variant={selectedRoleIds.includes(role.id) ? 'primary' : 'light'}
            size="xs"
            onClick={() => onToggle(role.id)}
          />
        ))}
      </div>
    </div>
  );
}
